import {
    getFirestore,
    doc,
    getDoc,
    collection,
    getDocs,
    query,
    where,
    getCountFromServer,
  } from "firebase/firestore";
import { Result } from "../../models/result";
import { User } from "../../models/user/user";
import httpRepo from "../httpRepo";
import { agentEndpoints } from "../apiConfig";


export const generateStudentPerformanceReport = async (schoolId, admissionNo) => {
    try {
        const body = {
            schoolInfo: {
                schoolId: schoolId,
            },
            admissionNo: admissionNo,
        };
        const result = await httpRepo.post(agentEndpoints.generateStudentReport, body, {isPublicAPI: true});
        return result;
    } catch (ex) {
        return new Result({
            message: ex.message,
        });
    }
}


export const getUsersOfClass = async (schoolId, classId, sec) => {
   try{
    const db = getFirestore();
    const studentsCollectionRef = collection(db, "schools", schoolId, "users");
    const q = query(studentsCollectionRef, where("Class", "==", Number(classId)), where("sec", "==", sec),
where("type", "==", 1), where("blocked", "==", false));
    const querySnapshot = await getDocs(q);
    const students = [];
    querySnapshot.forEach((doc) => {
        students.push({
            userId: doc.id,
            ...doc.data(),
        });
    });
    return new Result({
        value: students,
    });
   }catch(ex){
    return new Result({
        error: ex.message,
    });
}
}

export const getTotalNumberOfActiveStudents = async (schoolId) => {
    try{
        const db = getFirestore();
        const studentsCollectionRef = collection(db, "schools", schoolId, "users");
        const q = query(studentsCollectionRef, where("type", "==", 1), where("blocked", "==", false));
        const count = await getCountFromServer(q);
        return new Result({
            value: count.data().count,
        });
    }catch(ex){
        console.log(ex);
        return new Result({
            message: ex.message,
        });
    }
}

/**
 * Gets students by admission numbers in batches
 * @param {string} schoolId - School ID
 * @param {string[]} admissionNos - Array of admission numbers
 * @returns {Promise<Result>} Result with valid and invalid arrays
 */
export const getStudentsByAdmissionNos = async (schoolId, admissionNos) => {
    try {
        if (!schoolId) {
            return new Result({
                message: "School ID is required",
            });
        }

        if (!admissionNos || !Array.isArray(admissionNos) || admissionNos.length === 0) {
            return new Result({
                value: {
                    valid: [],
                    invalid: []
                }
            });
        }

        const db = getFirestore();
        const usersRef = collection(db, "schools", schoolId, "users");
        
        // Remove duplicates and filter out empty values
        const uniqueAdmissionNos = [...new Set(admissionNos.filter(no => no && no.trim()))];
        
        const batchSize = 10;
        const valid = [];
        const invalid = [];
        const foundAdmissionNos = new Set();

        // Process admission numbers in batches of 10 (Firestore 'in' query limit)
        for (let i = 0; i < uniqueAdmissionNos.length; i += batchSize) {
            const batch = uniqueAdmissionNos.slice(i, i + batchSize);
            
            try {
                // Query for students with type=1 (student) and not blocked
                const q = query(
                    usersRef, 
                    where("admissionNo", "in", batch),
                    where("type", "==", 1)
                );
                
                const querySnapshot = await getDocs(q);
                
                querySnapshot.forEach((doc) => {
                    const studentData = doc.data();
                    const student = {
                        userId: doc.id,
                        ...studentData
                    };
                    
                    valid.push(student);
                    foundAdmissionNos.add(studentData.admissionNo);
                });

            } catch (batchError) {
                console.error(`Error processing batch ${i}-${i + batchSize}:`, batchError);
                // Add the batch to invalid if there's an error
                batch.forEach(admissionNo => {
                    if (!foundAdmissionNos.has(admissionNo)) {
                        invalid.push({
                            admissionNo,
                            error: `Batch query error: ${batchError.message}`
                        });
                    }
                });
            }
        }

        // Find admission numbers that were not found in any batch
        uniqueAdmissionNos.forEach(admissionNo => {
            if (!foundAdmissionNos.has(admissionNo)) {
                invalid.push({
                    admissionNo,
                    error: "Student not found or inactive"
                });
            }
        });

        return new Result({
            value: {
                valid,
                invalid
            }
        });

    } catch (ex) {
        console.error("Error in getStudentsByAdmissionNos:", ex);
        return new Result({
            message: ex.message,
        });
    }
}

